import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class FormErrorService {
    showError(formGroup: UntypedFormGroup, formControlName: string): boolean {
        const formControl = formGroup.get(formControlName) as UntypedFormControl;
        return !formControl.valid && (formControl.touched || formControl.dirty);
    }

    getErrorMessage(formGroup: UntypedFormGroup, formControlName: string): string {
        const formControl = formGroup.get(formControlName) as UntypedFormControl;
        if (formControl.hasError('required')) {
            return 'You must enter a value';
        } else if (formControl.hasError('unique')) {
            return 'Value must be unique';
        }
    }
}
